<script setup lang="ts">
import { onMounted, ref } from 'vue'

const visible = ref(false)
const KEY = 'cs_ios_install_dismissed'

onMounted(() => {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return
  const ua = navigator.userAgent || ''
  const isIos = /iP(hone|ad|od)/.test(ua) && !(window as any).MSStream
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as any).standalone === true
  let dismissed = false
  try { dismissed = localStorage.getItem(KEY) === '1' } catch { /* ignore */ }
  visible.value = isIos && !isStandalone && !dismissed
})

function dismiss() {
  visible.value = false
  try { localStorage.setItem(KEY, '1') } catch { /* ignore */ }
}
</script>

<template>
  <div v-if="visible" class="cs-ios-nudge" role="note">
    <span>
      Install <strong>ClaimShield Ops</strong> for notifications: tap
      <span class="cs-ios-share">Share</span>, then "Add to Home Screen".
    </span>
    <button type="button" class="cs-ios-x" aria-label="Dismiss" @click="dismiss">✕</button>
  </div>
</template>

<style scoped>
.cs-ios-nudge {
  display: flex; align-items: center; gap: 0.75rem;
  padding: 0.6rem 1rem; font-size: 0.85rem;
  background: theme('colors.secondary.800'); color: #fff;
}
.cs-ios-share { text-decoration: underline; }
.cs-ios-x {
  margin-left: auto; background: transparent; border: 0; color: #fff;
  cursor: pointer; font-size: 1rem; line-height: 1; padding: 0.25rem;
}
</style>
